document.addEventListener('DOMContentLoaded', function() {
  initializeCleanCarousels();
  
  // Re-initialize carousels when section:load events fire (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    initializeCleanCarousels();
  });
});

function initializeCleanCarousels() {
  const carousels = document.querySelectorAll('.custom-image-carousel');
  
  carousels.forEach(carousel => {
    // Skip if already initialized or empty
    if (carousel.dataset.initialized === 'true' || carousel.children.length === 0) return;
    
    // Set as initialized
    carousel.dataset.initialized = 'true';
    
    // Initialize variables and get elements
    const mainImageContainer = carousel.querySelector('.carousel-main-image');
    const thumbnails = Array.from(carousel.querySelectorAll('.carousel-thumbnail'));
    const thumbnailsContainer = carousel.querySelector('.carousel-thumbnails');
    const thumbnailPrevButton = carousel.querySelector('.carousel-prev-btn');
    const thumbnailNextButton = carousel.querySelector('.carousel-next-btn');
    
    // Exit if no thumbnails or no main image container
    if (thumbnails.length === 0 || !mainImageContainer) return;
    
    // Core variables
    let currentIndex = 0;
    let touchStartX = 0;
    let touchEndX = 0;
    let autoRotateTimer = null;
    let isUserInteracting = false;
    let isAnimating = false;
    
    // Get autoRotate settings from data attributes or use defaults
    const autoRotate = carousel.dataset.autoRotate !== 'false';
    const autoRotateDelay = parseInt(carousel.dataset.autoRotateDelay) || 6000; // 6 seconds by default
    
    // Store the total number of thumbnails for reference
    const totalThumbnails = thumbnails.length;
    
    // Function to adjust thumbnails container width based on the number of thumbnails
    function adjustThumbnailsContainerWidth() {
      if (!thumbnailsContainer || thumbnails.length === 0) return;
      
      const thumbWidth = thumbnails[0].offsetWidth;
      const thumbGap = parseInt(window.getComputedStyle(thumbnailsContainer).getPropertyValue('gap')) || 10;
      
      // Determine how many thumbnails are visible at once (from CSS variables)
      const isMobile = window.innerWidth <= 749;
      const maxVisibleThumbs = isMobile ? 4 : 5;
      
      // If there are fewer thumbnails than the maximum visible amount,
      // adjust the container width to fit only the available thumbnails
      if (thumbnails.length < maxVisibleThumbs) {
        const newWidth = (thumbnails.length * thumbWidth) + ((thumbnails.length - 1) * thumbGap);
        thumbnailsContainer.style.width = newWidth + 'px';
        thumbnailsContainer.style.maxWidth = newWidth + 'px';
      } else {
        // Reset to default width if there are more thumbnails than visible
        thumbnailsContainer.style.width = '';
        thumbnailsContainer.style.maxWidth = '';
      }
    }
    
    // Call the function initially
    adjustThumbnailsContainerWidth();
    
    // Function to show a specific slide
    function showSlide(index, direction = 'left') {
      // Don't do anything if we're already animating
      if (isAnimating) return;
      
      // Ensure index is within bounds
      if (index < 0) {
        index = totalThumbnails - 1;
        direction = 'right';
      }
      if (index >= totalThumbnails) {
        index = 0;
        direction = 'left';
      }
      
      // If it's the same slide, do nothing
      if (index === currentIndex) return;
      
      // Calculate natural direction if not specified
      if (direction === 'auto') {
        direction = index > currentIndex ? 'left' : 'right';
        // Handle wrap-around cases
        if (index === 0 && currentIndex === totalThumbnails - 1) direction = 'left';
        if (index === totalThumbnails - 1 && currentIndex === 0) direction = 'right';
      }
      
      // Lock animation
      isAnimating = true;
      
      // Update currentIndex
      const previousIndex = currentIndex;
      currentIndex = index;
      
      // Get new image source and alt
      const newSrc = thumbnails[index].querySelector('img').getAttribute('data-full-img');
      const newAlt = thumbnails[index].getAttribute('aria-label') || '';
      
      // IMPROVED ANIMATION APPROACH
      // ----------------------------------------
      
      // 1. Create container for slide animation
      const slideContainer = mainImageContainer;
      slideContainer.style.position = 'relative';
      slideContainer.style.overflow = 'hidden';
      
      // 2. Create current and new image elements
      const currentImage = slideContainer.querySelector('img') || null;
      const newImage = document.createElement('img');
      
      // 3. Prepare new image
      newImage.src = newSrc;
      newImage.alt = newAlt;
      newImage.style.position = 'absolute';
      newImage.style.top = '0';
      newImage.style.left = '0';
      newImage.style.width = '100%';
      newImage.style.height = '100%';
      newImage.style.objectFit = 'contain';
      
      // 4. Set initial positions based on direction
      if (direction === 'left') {
        newImage.style.transform = 'translateX(100%)';
      } else {
        newImage.style.transform = 'translateX(-100%)';
      }
      
      // 5. Add new image to container
      slideContainer.appendChild(newImage);
      
      // 6. Prepare animation
      const animationDuration = 400; // ms
      const easing = 'cubic-bezier(0.4, 0, 0.2, 1)';
      
      // 7. Animate images
      requestAnimationFrame(() => {
        // Animate out current image
        if (currentImage) {
          currentImage.style.transition = `transform ${animationDuration}ms ${easing}, opacity ${animationDuration}ms ${easing}`;
          
          if (direction === 'left') {
            currentImage.style.transform = 'translateX(-100%)';
          } else {
            currentImage.style.transform = 'translateX(100%)';
          }
          
          currentImage.style.opacity = '0';
        }
        
        // Animate in new image
        newImage.style.transition = `transform ${animationDuration}ms ${easing}`;
        newImage.style.transform = 'translateX(0)';
      });
      
      // 8. Clean up after animation
      setTimeout(() => {
        // Remove old image
        if (currentImage) {
          slideContainer.removeChild(currentImage);
        }
        
        // Reset new image styles
        newImage.style.position = 'static';
        newImage.style.transform = '';
        newImage.style.transition = '';
        
        // Unlock animation
        isAnimating = false;
      }, animationDuration + 50);
      
      // Update thumbnails - remove overlay from active, add to others
      thumbnails.forEach((thumbnail, i) => {
        if (i === index) {
          thumbnail.classList.add('active');
          thumbnail.classList.remove('overlay');
        } else {
          thumbnail.classList.remove('active');
          thumbnail.classList.add('overlay');
        }
      });
      
      // Scroll thumbnails to make active one visible
      scrollThumbnailsToActive();
      
      // Reset auto-rotation timer
      resetAutoRotateTimer();
    }
    
    // Function to start/reset the auto-rotation timer
    function resetAutoRotateTimer() {
      // Clear any existing timer
      if (autoRotateTimer) {
        clearTimeout(autoRotateTimer);
        autoRotateTimer = null;
      }
      
      // Only set new timer if auto-rotate is enabled and user is not interacting
      if (autoRotate && !isUserInteracting && totalThumbnails > 1) {
        // Set main timer
        autoRotateTimer = setTimeout(() => {
          showSlide(currentIndex + 1, 'left'); // Always slide left for auto rotation
        }, autoRotateDelay);
      }
    }
    
    // Function to go to previous slide
    function prevSlide() {
      showSlide(currentIndex - 1, 'right');
    }
    
    // Function to go to next slide
    function nextSlide() {
      showSlide(currentIndex + 1, 'left');
    }
    
    // Function to scroll thumbnails container to show active thumbnail
    function scrollThumbnailsToActive() {
      if (!thumbnailsContainer) return;
      
      const activeThumb = thumbnails[currentIndex];
      const thumbWidth = activeThumb.offsetWidth;
      const thumbGap = parseInt(window.getComputedStyle(thumbnailsContainer).getPropertyValue('gap')) || 10;
      
      // Determine how many thumbnails are visible at once
      const isMobile = window.innerWidth <= 749;
      const visibleThumbs = isMobile ? 4 : 5;
      
      // If there are fewer thumbnails than the maximum visible amount,
      // no need to scroll as they all fit and are centered by CSS
      if (thumbnails.length <= visibleThumbs) {
        thumbnailsContainer.scrollLeft = 0;
        return;
      }
      
      // Calculate position of active thumbnail
      const activeThumbPosition = activeThumb.offsetLeft;
      
      // Calculate width of a single thumbnail including gap
      const thumbUnitWidth = thumbWidth + thumbGap;
      
      // Calculate total width of visible thumbnail area
      const visibleWidth = visibleThumbs * thumbUnitWidth - thumbGap;
      
      // Determine current visible window start and end
      const currentScrollLeft = thumbnailsContainer.scrollLeft;
      const scrollViewStart = currentScrollLeft;
      const scrollViewEnd = currentScrollLeft + visibleWidth;
      
      // Check if active thumbnail is outside visible area
      if (activeThumbPosition < scrollViewStart || 
          activeThumbPosition + thumbWidth > scrollViewEnd) {
        
        // Calculate the ideal position - we want the active thumbnail to be centered or at the start of a group
        let targetGroup = Math.floor(currentIndex / visibleThumbs);
        let targetScroll = targetGroup * visibleWidth;
        
        // Make sure we don't scroll beyond the start or end
        const maxScroll = thumbnailsContainer.scrollWidth - visibleWidth;
        targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));
        
        // Scroll to position
        thumbnailsContainer.scrollTo({
          left: targetScroll,
          behavior: 'smooth'
        });
      }
    }
    
    // Initialize carousel with first image
    // Make sure the first image is loaded
    const firstImage = mainImageContainer.querySelector('img');
    if (!firstImage) {
      const initialImage = document.createElement('img');
      initialImage.src = thumbnails[0].querySelector('img').getAttribute('data-full-img');
      initialImage.alt = thumbnails[0].getAttribute('aria-label') || '';
      initialImage.style.width = '100%';
      initialImage.style.height = '100%';
      initialImage.style.objectFit = 'contain';
      initialImage.style.display = 'block';
      mainImageContainer.appendChild(initialImage);
    }
    
    // Reset scroll position to start
    setTimeout(() => {
      if (thumbnailsContainer) {
        thumbnailsContainer.scrollLeft = 0;
      }
    }, 100);
    
    // Set up user interaction tracking
    carousel.addEventListener('mouseenter', () => {
      isUserInteracting = true;
      if (autoRotateTimer) {
        clearTimeout(autoRotateTimer);
        autoRotateTimer = null;
      }
    });
    
    carousel.addEventListener('mouseleave', () => {
      isUserInteracting = false;
      resetAutoRotateTimer();
    });
    
    carousel.addEventListener('touchstart', () => {
      isUserInteracting = true;
      if (autoRotateTimer) {
        clearTimeout(autoRotateTimer);
        autoRotateTimer = null;
      }
    }, { passive: true });
    
    // Start auto-rotation after page is loaded
    if (autoRotate && totalThumbnails > 1) {
      // Wait for page to fully load before starting auto-rotation
      window.addEventListener('load', () => {
        resetAutoRotateTimer();
      });
    }
    
    // Click event for thumbnails
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', function() {
        // Determine direction based on index difference
        const direction = index > currentIndex ? 'left' : 'right';
        showSlide(index, direction);
      });
    });
    
    // Previous and Next button functionality for thumbnails
    if (thumbnailPrevButton) {
      thumbnailPrevButton.addEventListener('click', prevSlide);
    }
    
    if (thumbnailNextButton) {
      thumbnailNextButton.addEventListener('click', nextSlide);
    }
    
    // Enhanced Touch swipe handling for main image on mobile
    if (mainImageContainer) {
      // Add variables for enhanced touch handling
      let touchMoveX = 0;
      let touchDeltaX = 0;
      let isSwiping = false;
      let swipeStartTime = 0;
      let currentTranslate = 0;
      
      // Add visual swipe hint for first-time mobile users
      const swipeHint = document.createElement('div');
      swipeHint.className = 'swipe-hint';
      swipeHint.textContent = 'Swipe to navigate';
      swipeHint.style.opacity = '0';
      mainImageContainer.appendChild(swipeHint);
      
      // Show swipe hint briefly on first interaction
      let hasShownSwipeHint = false;
      
      // Function to show swipe hint
      function showSwipeHint() {
        if (!hasShownSwipeHint) {
          hasShownSwipeHint = true;
          swipeHint.style.opacity = '1';
          
          setTimeout(() => {
            swipeHint.style.opacity = '0';
          }, 2000);
        }
      }
      
      // Touch start event
      mainImageContainer.addEventListener('touchstart', function(e) {
        if (isAnimating) return;
        
        touchStartX = e.changedTouches[0].screenX;
        swipeStartTime = Date.now();
        isSwiping = true;
        
        // Show swipe hint on first interaction
        showSwipeHint();
        
        // Get current image for manipulation during swipe
        const currentImage = mainImageContainer.querySelector('img');
        if (currentImage) {
          currentImage.style.transition = 'none';
        }
      }, {passive: true});
      
      // Touch move event - provide visual feedback during the swipe
      mainImageContainer.addEventListener('touchmove', function(e) {
        if (!isSwiping || isAnimating) return;
        
        touchMoveX = e.changedTouches[0].screenX;
        touchDeltaX = touchMoveX - touchStartX;
        
        // Apply a resistance factor to make the swipe feel more natural
        const resistance = 0.4;
        currentTranslate = touchDeltaX * resistance;
        
        // Move the current image to provide visual feedback
        const currentImage = mainImageContainer.querySelector('img');
        if (currentImage) {
          currentImage.style.transform = `translateX(${currentTranslate}px)`;
        }
        
        // Add visual feedback classes based on swipe direction
        if (touchDeltaX < -20) {
          mainImageContainer.classList.add('swiping', 'swiping-left');
          mainImageContainer.classList.remove('swiping-right');
        } else if (touchDeltaX > 20) {
          mainImageContainer.classList.add('swiping', 'swiping-right');
          mainImageContainer.classList.remove('swiping-left');
        } else {
          mainImageContainer.classList.remove('swiping', 'swiping-left', 'swiping-right');
        }
      }, {passive: true});
      
      // Touch end event
      mainImageContainer.addEventListener('touchend', function(e) {
        if (!isSwiping || isAnimating) return;
        
        touchEndX = e.changedTouches[0].screenX;
        isSwiping = false;
        
        // Calculate velocity for quick swipes
        const swipeDuration = Date.now() - swipeStartTime;
        const swipeDistance = touchEndX - touchStartX;
        const swipeVelocity = Math.abs(swipeDistance) / swipeDuration;
        
        // Reset the image transform
        const currentImage = mainImageContainer.querySelector('img');
        if (currentImage) {
          currentImage.style.transition = 'transform 0.3s ease';
          currentImage.style.transform = 'translateX(0)';
        }
        
        // Remove swipe classes
        mainImageContainer.classList.remove('swiping', 'swiping-left', 'swiping-right');
        
        // Enhanced swipe detection
        const swipeThreshold = swipeVelocity > 0.3 ? 30 : 50; // Lower threshold for quick swipes
        
        if (swipeDistance > swipeThreshold) {
          // Swiped right, go to previous image
          prevSlide();
        } else if (swipeDistance < -swipeThreshold) {
          // Swiped left, go to next image
          nextSlide();
        }
      }, {passive: true});
      
      // Cancel swipe on touch cancel
      mainImageContainer.addEventListener('touchcancel', function() {
        isSwiping = false;
        
        // Reset the image transform
        const currentImage = mainImageContainer.querySelector('img');
        if (currentImage) {
          currentImage.style.transition = 'transform 0.3s ease';
          currentImage.style.transform = 'translateX(0)';
        }
        
        // Remove swipe classes
        mainImageContainer.classList.remove('swiping', 'swiping-left', 'swiping-right');
      }, {passive: true});
    }
    
    // SIMPLIFIED THUMBNAIL SWIPING
    // Much more responsive and easy to use
    if (thumbnailsContainer && thumbnails.length > 0) {
      // Variables for tracking touch
      let thumbIsDragging = false;
      let thumbStartX = 0;
      let thumbStartScrollLeft = 0;
      
      // Show thumbnail swipe hint once on mobile
      if (window.innerWidth <= 749 && thumbnails.length > (window.innerWidth <= 749 ? 4 : 5)) {
        const hint = document.createElement('div');
        hint.className = 'thumbnail-swipe-hint';
        hint.textContent = 'Swipe for more';
        hint.style.opacity = '0';
        thumbnailsContainer.parentNode.appendChild(hint);
        
        // Show hint briefly
        setTimeout(() => {
          hint.style.opacity = '1';
          setTimeout(() => hint.style.opacity = '0', 2000);
        }, 1000);
      }
      
      // TOUCH EVENTS - Simple 1:1 touch tracking for direct control
      thumbnailsContainer.addEventListener('touchstart', function(e) {
        thumbIsDragging = true;
        thumbStartX = e.touches[0].clientX;
        thumbStartScrollLeft = this.scrollLeft;
        
        // Always use auto during actual dragging for best responsiveness
        this.style.scrollBehavior = 'auto';
      }, { passive: true });
      
      thumbnailsContainer.addEventListener('touchmove', function(e) {
        if (!thumbIsDragging) return;
        
        // Simple direct scrolling - move exactly with finger
        const x = e.touches[0].clientX;
        const walk = thumbStartX - x;
        this.scrollLeft = thumbStartScrollLeft + walk;
      }, { passive: true });
      
      // Touch end - just stop where we are
      function endThumbnailTouch() {
        thumbIsDragging = false;
        thumbnailsContainer.style.scrollBehavior = 'smooth';
      }
      
      thumbnailsContainer.addEventListener('touchend', endThumbnailTouch, { passive: true });
      thumbnailsContainer.addEventListener('touchcancel', endThumbnailTouch, { passive: true });
      
      // MOUSE EVENTS - Same simple concept for mouse users
      thumbnailsContainer.addEventListener('mousedown', function(e) {
        e.preventDefault();
        thumbIsDragging = true;
        thumbStartX = e.pageX;
        thumbStartScrollLeft = this.scrollLeft;
        this.style.cursor = 'grabbing';
        this.style.scrollBehavior = 'auto';
      });
      
      thumbnailsContainer.addEventListener('mousemove', function(e) {
        if (!thumbIsDragging) return;
        
        const x = e.pageX;
        const walk = thumbStartX - x;
        this.scrollLeft = thumbStartScrollLeft + walk;
      });
      
      function endThumbnailMouse() {
        thumbIsDragging = false;
        thumbnailsContainer.style.cursor = 'grab';
        thumbnailsContainer.style.scrollBehavior = 'smooth';
      }
      
      thumbnailsContainer.addEventListener('mouseup', endThumbnailMouse);
      thumbnailsContainer.addEventListener('mouseleave', endThumbnailMouse);
      
      // Set appropriate cursor based on thumbnail count
      function updateThumbnailsCursor() {
        const hasExtraThumbnails = thumbnails.length > (window.innerWidth <= 749 ? 4 : 5);
        thumbnailsContainer.style.cursor = hasExtraThumbnails ? 'grab' : 'default';
      }
      
      // Initialize cursor and update on resize
      updateThumbnailsCursor();
      window.addEventListener('resize', updateThumbnailsCursor);
    }
    
    // Re-run adjustThumbnailsContainerWidth on window resize
    window.addEventListener('resize', adjustThumbnailsContainerWidth);
    
    // Run it again after images are loaded
    window.addEventListener('load', adjustThumbnailsContainerWidth);
    
    // Prevent double-tap zoom on iOS for carousel navigation buttons
    if (thumbnailPrevButton && thumbnailNextButton) {
      thumbnailPrevButton.style.touchAction = 'manipulation';
      thumbnailNextButton.style.touchAction = 'manipulation';
      thumbnailPrevButton.style.webkitTapHighlightColor = 'transparent';
      thumbnailNextButton.style.webkitTapHighlightColor = 'transparent';
    }
    
    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      // Only handle keypresses if this carousel is in the viewport
      const rect = carousel.getBoundingClientRect();
      const isInViewport = (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
      
      if (isInViewport) {
        if (e.key === 'ArrowLeft') {
          prevSlide();
          e.preventDefault();
        } else if (e.key === 'ArrowRight') {
          nextSlide();
          e.preventDefault();
        }
      }
    });
    
    // Remove any overlay elements that might have been created
    const elementsToRemove = [
      '.carousel-pagination',
      '.carousel-progress',
      '.carousel-main-nav-btn',
      '.carousel-zoom-controls',
      '.carousel-caption',
      '.carousel-image-loading',
      '.swipe-hint'
    ];
    
    elementsToRemove.forEach(selector => {
      const elements = carousel.querySelectorAll(selector);
      elements.forEach(el => el.remove());
    });
  });
}